export default __webpack_public_path__ + "static/media/img-45-drake.ca697f01.jpg";